// extracted by mini-css-extract-plugin
export default {"root":"vThbdN","paper":"E14_kn","content":"hdp8v6"};